<template>
    <div class="subscription-banner" :class="{'hide-banner' : timeExpired, 'move-left' : moveLeft}">
       
        <div v-if="!timeExpired" class="banner-wrapper">
            <div class="banner-location" @click="moveLeft = !moveLeft">
                <div v-show="!moveLeft"> 
                    <i class="fa-light fa-chevron-left"></i>
                </div>  
                <div v-show="moveLeft">
                    <i class="fa-light fa-chevron-right"></i>
                </div>
            </div>
            <div class="text-content">
                <h1>{{versionIsTrial ? $t('subscription-banner.title-trial') : $t('subscription-banner.title-cancelled')}}</h1>
                <p>{{versionIsTrial ? $t('subscription-banner.description-trial') : $t('subscription-banner.description-cancelled')}}</p>
            </div>
            <div class="countdown">
                <div class="time-display">
                    <span>{{displayDays}}</span> 
                    <span class="value">D</span> 
                </div>
                <div class="time-display">
                    <span>{{displayHours}}</span> 
                    <span class="value">{{$t('subscription-banner.hours')}}</span> 
                </div>
                <div class="time-display">
                    <span>{{displayMinutes}}</span> 
                    <span class="value">M</span> 
                </div>
                <div class="time-display">
                    <span>{{displaySeconds}}</span> 
                    <span class="value">S</span> 
                </div>
            </div>
            <div class="actions">
                <router-link class="btn btn-primary" :to="{ name: 'settings.subscription' }">
                    {{versionIsTrial ? $t('subscription-banner.btn-trial') : $t('subscription-banner.btn-cancelled')}}
                </router-link> 
            </div>
        </div>
    </div>

</template>

<script>
export default {
 data(){
     return {
        displayDays: null,
        displayHours: null,
        displayMinutes: null,
        displaySeconds: null,
        // now: new Date(),
        endDate: new Date('January 14, 2022 14:42:20'),
        timeExpired: false,
        moveLeft: false
     }
 },
    computed: {
        seconds(){return 1000},
        minutes(){return this.seconds * 60},
        hours(){return  this.minutes * 60},
        days(){return this.hours * 24},
        versionIsTrial(){
            return this.$store.getters.versionIsTrial
        }
    },
    methods: {
        formatTime(number){
            return number < 10 ? "0" + number : number
        },
        remainingTime(){  
            let timer = setInterval(() => {
                const now =  new Date()
                const endDate = this.endDate
                const timeSpan =  endDate.getTime() - now.getTime()
    
                if(timeSpan < 0 ) {
                    this.handleTrialExpired()
                    clearInterval(timer)
                }
                const days = Math.floor(timeSpan / this.days)
                const hours = Math.floor((timeSpan % this.days) / this.hours)
                const minutes = Math.floor((timeSpan % this.hours) / this.minutes)
                const seconds = Math.floor((timeSpan % this.minutes) / this.seconds)
                this.displayDays = this.formatTime(days)
                this.displayHours = this.formatTime(hours)
                this.displayMinutes = this.formatTime(minutes)
                this.displaySeconds = this.formatTime(seconds)

            }, 1000);
        },
        handleTrialExpired(){
            this.$store.dispatch('handleExpiredPlan')
            this.timeExpired = true
            this.$store.state.planExpired = true
        }
    },
    mounted(){
        this.remainingTime()
    }
}
</script>

<style lang="less">
.subscription-banner{
    opacity: 1;
    // transition: .4s;
    position: absolute;
    z-index: 9999;
    bottom: 20px;
    right: 20px;
    background-color: var(--background-white);
    border-radius: var(--standard-border-radius);
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.25);
    padding: 20px;
    
    .banner-wrapper{        
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        position: relative;

        h1{
            margin: 0;
            font-size: 18px;
            font-weight: normal;
        }
        p{
            margin: 0;
            opacity: .7;
            font-size: 12px;
        }
        .countdown{
            margin: 12px 0 ;
            display: flex;
            gap: 4px;
        }
        .time-display{
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            
            background-color: #fafafa;
            height: 32px;
            width: 32px;
            box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.05);
            -webkit-box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.05);
            text-align: center;
            .value{
                position: absolute;
                bottom: 100%;
                font-size: 10px;
                opacity: .7;
            }
        }
        .text-content{
            display: flex;
            flex-direction: column;
        }
        .banner-location{
            cursor: pointer;
            // position: absolute;
            top: -6px;
            right: 0;
            font-size: 10px;
        }

    }
}
.hide-banner{
    opacity: 0;
}
.move-left{
    left: 20px;
    right: unset;
}

</style>